import * as yup from 'yup';

export const editCategorySchema = yup.object().shape({
  titleAm: yup.string().required('Title is required'),
  titleEn: yup.string().required('Title is required'),
  titleRu: yup.string().required('Title is required'),
});
